import { createSlice } from "@reduxjs/toolkit";
import http from "../../common/cticApi";

// initial state
export const initialState = {
  loading: false,
  error: null,
  success: false,
};

// our slice
const forgotPasswordSlice = createSlice({
  name: "forgotPassword",
  initialState,
  reducers: {
    setLoading: (state) => {
      state.loading = true;
    },
    setError: (state, { payload }) => {
      state.loading = false;
      state.error = payload;
      state.success = false;
    },
    setSuccess: (state) => {
      state.loading = false;
      state.error = false;
      state.success = true;
    },
    reset: (state) => {
      state.loading = false;
      state.error = false;
      state.success = false;
    },
  },
});
// export the actions
export const { setLoading, setError, setSuccess, reset } =
  forgotPasswordSlice.actions;

export const forgotPasswordSelector = (state) => state.forgotPassword;

// export the default reducer
export default forgotPasswordSlice.reducer;

// forgot password
export const forgotPassword = (email) => async (dispatch) => {
  try {
    dispatch(setLoading());
    let requestData = {
      Email: email,
    };

    let { data: response } = await http.post(
      "/User/ForgotPassword",
      requestData
    );
    if (response.responseCode == 0) {
      dispatch(setSuccess());
    } else {
      dispatch(setError(response.responseDescription));
    }
  } catch (error) {
    const errorMessage =
      error.response && error.response.data
        ? error.response.data.title
        : error.message;
    dispatch(setError(errorMessage));
  }
};
